module.exports = __webpack_public_path__ + "img/logo-ontaneda.8995650a.png";